import App from '@/App';
import '@/index.css';
import reportWebVitals from '@/reportWebVitals';
import { SentryService } from '@propify-auth-client/services';
import * as React from 'react';
import ReactDOM from 'react-dom';

SentryService.init();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
